import React, { useState, useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import emailjs from '@emailjs/browser';
import Notiflix from 'notiflix';
import { MapPinIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid';
import linkdinLogo from '../images/linkedin.svg';
import instaLogo from '../images/insta.png';
import ytLogo from '../images/yt.png';
import { Link, useLocation } from 'react-router-dom';

const Contact = () => {
    useDocTitle('Technodevotion - Send us a message')
    const location = useLocation();
    const isDemoRequest = location.state?.isDemoRequest;
    const productName = location.state?.productName;
    const prefillMessage = location.state?.prefillMessage;
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState(
      prefillMessage
        ? prefillMessage
        : isDemoRequest
        ? `I would like to schedule a demo for ${productName}.`
        : ''
    );
    const [errors, setErrors] = useState([])

    useEffect(() => {
        // Check if there's a hash in the URL
        if (window.location.hash === '#contact') {
            // Scroll to the contact section
            const contactSection = document.getElementById('contact');
            if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
            }
            // Clear the message if not coming from demo request
            if (!isDemoRequest && !prefillMessage) {
                setMessage('');
            }
        }
    }, [isDemoRequest, prefillMessage]);

    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }

    const sendEmail = (e) => {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Loading...';

        // Prepare data
        const TO_NAME = "Technodevotion LLP";
        const fData = {
            from_name: firstName + ' ' + lastName,
            to_name: TO_NAME,
            message: message,
            phone: phone ?? 'Not Provided',
            reply_to: email,
        };

        // Send email
        if (firstName && lastName && email && message) {
            const serviceId = 'service_k42neo6';
            const templateId = 'template_aclhk1n';
            emailjs.send(serviceId, templateId, fData, process.env.EMAIL_JS_PUBLIC_KEY ?? 'HpzTHrTJ3onO-OQ-x')
                .then(() => {
                    document.getElementById('submitBtn').disabled = false;
                    document.getElementById('submitBtn').innerHTML = 'send message';
                    clearInput()
                    console.log('SUCCESS!');
                    // Handle success
                    Notiflix.Report.success(
                        'Success',
                        'A Message sent successfully',
                        'Okay',
                    );

                })
                .catch(function (error) {
                    document.getElementById('submitBtn').disabled = false;
                    document.getElementById('submitBtn').innerHTML = 'send message';
                    console.error(error);
                    //handle error

                    Notiflix.Report.failure(
                        'An error occurred',
                        error.text,
                        'Okay',
                    );
                    setErrors(error)
                });
        } else {
            Notiflix.Report.failure(
                'An error occurred',
                'Please fill out all required fields',
                'Okay',
            );
        }
    }
    return (
        <>
            <div>
                <NavBar />
            </div>
            <div id='contact' className="flex justify-center items-center mt-8 w-full bg-gradient-to-r from-primary to-[#FF8C42] py-12 lg:py-24 ">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">

                    <form onSubmit={sendEmail}>
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="text-center lg:text-left text-primary uppercase font-heading text-heading xs:text-[1.25rem] xsm:text-[1.5rem] sm:text-[1.75rem] md:text-[2rem] lg:text-[2rem] xl:text-[2rem]">
                                    {isDemoRequest ? 'Schedule a Demo' : 'Send us a message'}
                                </h1>
                            </div>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <div>
                                    <input
                                        name="first_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="First Name*"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required
                                    />
                                    {errors && errors.first_name &&
                                        <p className="text-red-500 text-sm">{errors.first_name}</p>
                                    }
                                </div>

                                <div>
                                    <input
                                        name="last_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="Last Name*"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        onKeyUp={clearErrors}
                                        required
                                    />
                                    {errors && errors.last_name &&
                                        <p className="text-red-500 text-sm">{errors.last_name}</p>
                                    }
                                </div>

                                <div>
                                    <input
                                        name="email"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="email"
                                        placeholder="Email*"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={clearErrors}
                                        pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$^[\w]{1,}[\w.+-]{0,}@[\w-]{2,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$"
                                        title="Email address must be in the format: somebody@example.com"
                                        required
                                    />
                                    {errors && errors.email &&
                                        <p className="text-red-500 text-sm">{errors.email}</p>
                                    }
                                </div>

                                <div>
                                    <input
                                        name="phone_number"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="Phone*"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        onKeyUp={clearErrors}
                                        pattern="^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$"
                                        title="Phone number must be in the format: 9999999999"
                                        required
                                    />
                                    {errors && errors.phone_number &&
                                        <p className="text-red-500 text-sm">{errors.phone_number}</p>
                                    }
                                </div>
                            </div>
                            <div className="my-4">
                                <textarea
                                    name="message"
                                    placeholder="Message*"
                                    className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    onKeyUp={clearErrors}
                                    required
                                ></textarea>
                                {errors && errors.message &&
                                    <p className="text-red-500 text-sm">{errors.message}</p>
                                }
                            </div>
                            <div className="my-2 w-1/2 lg:w-2/4">
                                <button type="submit" id="submitBtn" className="font-bold tracking-wide bg-primary hover:bg-greyText text-secondary p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem]">
                                    {prefillMessage ? 'Apply' : isDemoRequest ? 'Schedule Demo' : 'Send Message'}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div
                        className="w-full  lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-greyText rounded-2xl">
                        <div className="flex flex-col text-primary">

                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <MapPinIcon className="h-6 w-6 text-primary pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="font-subheading text-subheading xs:text-[1rem] xsm:text-[1.25rem] sm:text-[1.5rem] md:text-[1.5rem] lg:text-[1.5rem] xl:text-[1.5rem]">Office Address</h2>
                                    <p className="text-secondary font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem]">Technodevotion LLP,
                                        Iscon park, Satellite road

                                        Ahmedabad - 380015.

                                        Gujarat, India</p>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                    <PhoneIcon className="h-6 w-6 text-primary pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                    <h2 className="font-subheading text-subheading xs:text-[1rem] xsm:text-[1.25rem] sm:text-[1.5rem] md:text-[1.5rem] lg:text-[1.5rem] xl:text-[1.5rem]">Call Us</h2>
                                    <p className="text-secondary font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem]">+91 7434017407</p>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                <EnvelopeIcon className="h-6 w-6 text-primary pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                <h2 className="font-subheading text-subheading xs:text-[1rem] xsm:text-[1.25rem] sm:text-[1.5rem] md:text-[1.5rem] lg:text-[1.5rem] xl:text-[1.5rem]">Send an E-mail</h2>
                                    <p className="text-secondary font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem]">contact@technodevotion.com</p>
                              </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2 gap-4">
                                <a href="https://www.linkedin.com/in/technodevotion-solutions-08a396369/" target="_blank" rel="noreferrer" className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 h-8 w-8 shadow transition duration-150 ease-in-out rounded-full pb-1.5" aria-label="Linkdin">
                                    <img src={linkdinLogo} alt="LinkedIn logo" />
                                </a>
                                <a href="https://instagram.com/technodevotion" target="_blank" rel="noreferrer" className="flex justify-center items-center h-8 w-8 transition duration-150 ease-in-out" aria-label="instagram">
                                    <img src={instaLogo} alt="Instagram logo" />
                                </a>
                                <a href="https://www.youtube.com/@technodevotion6157" target="_blank" rel="noreferrer" className="flex justify-center items-center h-8 w-8 transition duration-150 ease-in-out" aria-label="youtube">
                                    <img src={ytLogo} alt="YouTube logo" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>


    )
}

export default Contact;